export default __webpack_public_path__ + "static/pragicts-secops-services-consulting-28f6048818bc378f8ed52a8cd4e1c909.jpg";